<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row" v-if="hasSessionsRight">
                <div class="col-lg-7">
                    <sessions></sessions>
                </div>
                <div class="col-lg-5">
                    <logs></logs>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-lg-12">
                    <logs></logs>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <pwa-info></pwa-info>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import Logs from './offline/Logs';
    import Sessions from './offline/Sessions';
    import PwaInfo from './offline/PwaInfo';

    export default {

        components: {
            Logs, Sessions, PwaInfo
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('pwa.dashboard'),
                    },
                ]
            },

            hasSessionsRight() {
                // Don't use `this.$permissions.hasRight('dashboard.sessions.write')`
                // because rights are not set in this page which may be offline, so it would always return false.
                // Returns the server definition of this right.
                return this.$auth.user.admin || this.$auth.hasPermission('dashboard.access-instructor-dashboard')
            }
        },

        created() {
            this.$loader.hide()
        },
    }
</script>
